/* eslint-disable no-restricted-exports */
import { createTelemetry } from "@smakecloud/browser-telemetry";
import { attachVue } from "@smakecloud/browser-telemetry/vue";

// Requests without spans: Nuxt chunks, the collector itself, websockets, third-party scripts.
const IGNORE_URLS = [/\/_nuxt\//, /\/collect$/, /pusher|sockjs/, /fontawesome/];

export default defineNuxtPlugin({
    name: "telemetry",
    // the auth store uses vue-query mutations, so the query client has to be installed first
    dependsOn: ["vue-query"],
    setup(nuxtApp) {
        const { productionApiBaseUrl, telemetry } = useRuntimeConfig().public;

        if (!telemetry.enabled) {
            return;
        }

        // composables need the Nuxt context, so resolve them before the async start
        const router = useRouter();
        const authStore = useAuthStore();
        const slug = useSlug();

        // not awaited: the app does not wait for the Faro chunk
        void createTelemetry({
            apiOrigins: [productionApiBaseUrl],
            appName: "production-administration-browser",
            collectorUrl: "/collect",
            environment: telemetry.environment,
            ignoreUrls: IGNORE_URLS,
            sampleRate: telemetry.sampleRate,
            version: telemetry.version,
        }).then((faro) => {
            if (!faro) {
                return;
            }

            attachVue(nuxtApp, router, faro);

            // ids only (never staff_email or production_name); follows login, logout and slug changes
            watch(
                () => [authStore.payload, slug.value] as const,
                ([payload, handle = ""]) => {
                    if (payload) {
                        faro.api.setUser({
                            id: String(payload.staff_id),
                            attributes: {
                                production_id: String(payload.production_id),
                                slug: handle,
                            },
                        });
                    } else {
                        faro.api.resetUser();
                    }
                },
                { immediate: true },
            );
        });
    },
});
